import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { OffcanvasOptions } from '../../../../core/_base/layout';
import { select, Store } from '@ngrx/store';
import { AppState } from '../../../../core/reducers';
import { selectTwixorToken } from '../../../../core/auth';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'kt-twixor',
  templateUrl: './twixor.component.html',
  styleUrls: ['./twixor.component.scss'],
})
export class TwixorComponent implements OnInit {
  authenticationToken: string;
  display: boolean;
  url: any;
  offcanvasOptions: OffcanvasOptions = {
    overlay: true,
    baseClass: 'offcanvas',
    placement: 'right',
    closeBy: 'kt_twixor_close',
    toggleBy: 'kt_twixor_toggle',
  };

  ngOnInit() {
    this.setup();
  }

  setup() {
    this.store.pipe(select(selectTwixorToken)).subscribe((res) => {
      if (res) {
        this.authenticationToken = encodeURIComponent(res);
        this.url = this.sanitizer.bypassSecurityTrustResourceUrl(
          `${environment.TWIXOR_BASE}${this.authenticationToken}`,
        );
        this.display = true;
      }
      this.cdr.detectChanges();
    });
  }

  constructor(
    private cdr: ChangeDetectorRef,
    private sanitizer: DomSanitizer,
    private store: Store<AppState>,
  ) {}
}
